import styled from "styled-components"

export const StyledHome = styled.div`
  height: calc(
    100% - var(--app-top-navigation-height) - var(--fit-banner-height) -
      var(--profile-header-height)
  );

  background: #eeeeee;
  position: relative;
`

export const HomeMain = styled.div`
  --diary-header-height: 44px;
  --progress-bar-height: 168px;
  overflow-y: auto;
  padding: 16px var(--app-horizontal-padding);
  height: calc(100% - var(--diary-header-height));
  padding-top: 0;
  z-index: 1;
`

export const HomeMainInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 2;
  position: relative;
`

export const NoMealsBox = styled.div`
  border-radius: 8px;
  border: 0.5px solid rgba(0, 0, 0, 0.08);
  background: var(--Schemes-Primary-Container-Variant, #cceded);
  box-shadow: 0px 1px 6px 0px rgba(28, 31, 33, 0.06);
  padding: 12px 8px 12px 12px;
  width: 100%;
  flex-shrink: 0;
`

export const NoMealsTitle = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.24px;
  text-transform: uppercase;
  color: var(--Schemes-Primary, #0da3ba);
`

export const NoMealsText = styled.p`
  font-size: 12px;
  font-weight: 500;
  color: #1c1f21;
`

export const AIScanBoxSkeleton = styled.div`
  height: 88px;
  border-radius: var(--card_corner, 8px);
  background: var(--Loading, linear-gradient(270deg, #d5d5d5 0%, #fff 100%));
  box-shadow: 0px 1px 6px 0px rgba(28, 31, 33, 0.06);
  width: 100%;
  z-index: 1;
`

export const MealSectionSkeleton = styled(AIScanBoxSkeleton)`
  height: 58px;
`

export const BannerOverlay = styled.div<{ $height: number }>`
  background: linear-gradient(180deg, #05050c 0%, rgba(39, 20, 55, 0.07) 90.99%),
    #00263a;
  height: ${(props) => props.$height}px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
`

export const RecentMealDetailsOverlay = styled.div`
  --z-index-meal-details-overlay: 1000;

  height: 100%;
  position: fixed;
  inset: 0;
  z-index: var(--z-index-meal-details-overlay);
  max-width: var(--app-max-width);
  margin: 0 auto;
  background: #fff;
  overflow-y: auto;
`
